import debounce from "lodash/debounce";

export const CARD_STACK_BREAKPOINT = 992;
export const CARD_STACK_RESIZE_DEBOUNCE_MS = 350;

/**
 * Debounces isCardStacked updates so a window resize (or a drag across
 * CARD_STACK_BREAKPOINT) triggers one state update instead of one per
 * resize event.
 */
export const createCardStackResizeHandler = (
  setIsCardStacked,
  wait = CARD_STACK_RESIZE_DEBOUNCE_MS,
) =>
  debounce(() => {
    setIsCardStacked(window.innerWidth <= CARD_STACK_BREAKPOINT);
  }, wait);
